export const ISSUES_PAGE_LABELS = {
	ALL_ISSUES_TAB: 'All issues',
	UNIQUE_ISSUES_TAB: 'Unique issues',
	ALL_ISSUES_TABLE_TITLE: 'All Issues',
	UNIQUE_ISSUES_TABLE_TITLE: 'Unique Issues',
	ALL_ISSUES_TABLE_ARIA_LABEL: 'All Issues Table',
	UNIQUE_ISSUES_TABLE_ARIA_LABEL: 'Unique Issues Table',
	ALL_ISSUES_LOAD_ERROR: 'Failed to load all issues. Please try again.',
	UNIQUE_ISSUES_LOAD_ERROR: 'Failed to load unique issues. Please try again.',
	BACK_TO_MOBILE_DASHBOARD: 'Back to Mobile Dashboard'
} as const;
